module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_info_active-dbd1420c68e5c93dff0f755c026a1a21.svg";